import React, { Suspense } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Tokens } from "../constants/index.js";
import { getSecureItem, decodeJwtPayload } from '../lib/secureStorage';
import { route } from "./route.js";
import DashboardMaster from "@/layout/dashboard/DashboardMaster.jsx";
import Loading from "@/shared/common/Loading.js";
import { workspaceOfPath, mayEnterWorkspace, homePathFor, capabilitiesForPath, canOpenPath } from "@/hooks/useWorkspace";
import NoAccess from "@/components/common/NoAccess";

/**
 * W61 (WSP-001) · A route is admitted only to a member who holds a role in
 * its workspace. The organisation context loads asynchronously; until it
 * has, a workspace route shows the loader rather than either flashing a page
 * the member may not see or bouncing a member who may. A shared route with
 * no capability gate needs no context at all.
 *
 * Capability wave (3 Oct 2026, R-03) · Inside the workspace, a screen whose
 * reads the member's capabilities do not allow shows NoAccess — saying what
 * it needs — instead of rendering its own empty state over a refused read.
 */
const WorkspaceGuard = ({ path, children }) => {
    const context = useSelector((state) => state.organisationContext)
    const workspace = workspaceOfPath(path)
    if (workspace === 'shared' && !capabilitiesForPath(path)) return children
    if (!context?.loaded) {
        return <div className="flex justify-center items-center h-screen bg-white"><Loading /></div>
    }
    if (workspace !== 'shared' && !mayEnterWorkspace(context.roles, workspace)) {
        return <Navigate replace to={homePathFor(context.roles, context.capabilities)} />
    }
    if (!canOpenPath(path, context.roles, context.capabilities)) {
        return <NoAccess path={path} />
    }
    return children
}

export default function Router() {
    const token = getSecureItem(Tokens.ADMIN_TOKEN);
    const admin = getSecureItem(Tokens.ADMIN);
    let ActualAdminData = null;
    try { ActualAdminData = JSON.parse(admin); } catch { }
    const tokenPayload = decodeJwtPayload(token);
    const role = tokenPayload?.role ?? ActualAdminData?.role;
    const prepareRoutes = () => {

        let filterRoutes = [];
        route.forEach((route) => {
            if (route.permission === role) {
                filterRoutes.push(route)
            }
        });
        return filterRoutes;
    };

    const routes = prepareRoutes();
    return (
        <DashboardMaster>
            <Suspense fallback={<div className="flex justify-center items-center h-screen bg-white"><Loading /></div>}>
                {role === 'user' ? <Routes>
                    {routes.map((route, index) => {
                        return route.ele ? (
                            <Route key={index} exact={true} path={route.path} element={token ? <WorkspaceGuard path={route.path}>{route.ele}</WorkspaceGuard> : <Navigate replace to={"/signin"} />} />
                        ) : (null)
                    })}
                    <Route path='*' element={<Navigate replace to={"/"} />} />
                </Routes> :
                    <Routes>
                        {routes.map((route, index) => {
                            return route.ele ? (
                                <Route key={index} exact={true} path={route.path} element={token ? route.ele : <Navigate replace to={"/signin"} />} />
                            ) : (null)
                        })}
                        <Route path='*' element={<Navigate replace to={"/admin"} />} />
                    </Routes>}
            </Suspense>
        </DashboardMaster>
    )

}
